import React, { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Button, EmptyState, Modal, Select } from "@opendate-app/setlist";

export const applyBlueprint = (teamId, broadcastId, blueprintId, eventId = null) => {
  const token = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");
  if (token) axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
  const payload = eventId ? { blueprint_id: blueprintId, target: eventId } : { blueprint_id: blueprintId };
  return axios.post(`/teams/${teamId}/broadcasts/${broadcastId}/blueprint_application`, payload);
};

const errorMessage = (error) => error?.response?.data?.errors?.[0] || "Something went wrong. Please try again.";

const BlueprintEventPicker = ({ teamId, broadcastId, blueprint, onApply, onSkip, onApplied, onClose }) => {
  const [events, setEvents] = useState(null);
  const [eventId, setEventId] = useState(null);
  const [applying, setApplying] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`/teams/${teamId}/broadcasts/${broadcastId}/blueprint_events`)
      .then(({ data }) => setEvents(data))
      .catch((loadError) => setError(errorMessage(loadError)));
  }, [teamId, broadcastId]);

  const apply = () => {
    setApplying(true);
    setError(null);
    (onApply ? onApply(eventId) : applyBlueprint(teamId, broadcastId, blueprint.id, eventId))
      .then(onApplied)
      .catch((applyError) => { setError(errorMessage(applyError)); setApplying(false); });
  };

  const footer = (
    <>
      <Button variant="secondary" onClick={onSkip} disabled={applying}>Skip — keep placeholders</Button>
      {events?.length > 0 && (
        <Button variant="primary" onClick={apply} disabled={!eventId || applying}>{applying ? "Applying…" : "Use this event"}</Button>
      )}
    </>
  );

  return (
    <Modal open onClose={onClose} title="Which event?" description={`We'll fill ${blueprint.name} with this event's details.`} footer={footer}>
      {error && <Alert color="error" title={error} />}
      {events?.length === 0 && <EmptyState title="No recent or upcoming events at this venue" />}
      {events?.length > 0 && (
        <Select label="Event" options={events} value={eventId} onChange={setEventId} searchable placeholder="Search events" />
      )}
    </Modal>
  );
};

export default BlueprintEventPicker;
